import axios from 'axios'
import axiosRetry, { IAxiosRetryConfig } from 'axios-retry'

// if we have an env set, use it. otherwise, default is 10 seconds
const retryDelayInMilliseconds: number = process.env.AXIOS_RETRY_DELAY_IN_MILLISECONDS
  ? parseInt(process.env.AXIOS_RETRY_DELAY_IN_MILLISECONDS)
  : 10000

const retryCallback = () => {
  // logger.warn(`axios retry callback fired, retryCount: ${retryCount}, url: ${requestConfig.url}`)
  // logger.debug(`requestConfig: ${JSON.stringify(requestConfig)}`)
  // logger.debug(`axios error: ${JSON.stringify(error)}`)
}

export const setAxiosRetryPolicy = (axiosRetryConfig?: IAxiosRetryConfig) => {
  let policy: IAxiosRetryConfig = {
    retries: 3,
    retryDelay: () => {
      return retryDelayInMilliseconds
    },
    onRetry: retryCallback
  }

  if (axiosRetryConfig) {
    policy = axiosRetryConfig
  }

  axiosRetry(axios, policy)
}
